import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Header from "../components/header/Header";
import bg_dot from "../assets/images/bg_dot.png";
import bg from "../assets/images/bg.jpeg";
import hang1 from "../assets/images/hang1.png";
import hang2 from "../assets/images/hang2.png";
import hang3 from "../assets/images/hang3.png";
import hangkhac from "../assets/images/hangkhac.png";
import giaithuong from "../assets/images/giaithuong.png";
import hunghaumungtruyenthong from "../assets/images/banner_right_image.png";
import niemtinHUNGHAU from "../assets/images/niemtinHUNGHAU.png";
import leftBannerText from "../assets/images/banner_left_text.png";
import banner_bottom1 from "../assets/images/banner_bottom1.png";
import banner_bottom2 from "../assets/images/banner_bottom2.png";
import banner_bottom3 from "../assets/images/banner_bottom3.png";
import banner_bottom4 from "../assets/images/banner_bottom4.png";
import banner_bottom5 from "../assets/images/banner_bottom5.png";
import banner_bottom6 from "../assets/images/banner_bottom6.png";
import gioithieu1 from "../assets/images/gioithieu1.png";
import gioithieu2 from "../assets/images/gioithieu2.png";
import gioithieu3 from "../assets/images/gioithieu3.png";
import gioithieu4 from "../assets/images/gioithieu4.png";
import gioithieu5 from "../assets/images/gioithieu5.png";
import gioithieu6 from "../assets/images/gioithieu6.png";
import giaitoandoan from "../assets/images/giaitoandoan.png";
import giaiteamteambuiding from "../assets/images/giaiteamteambuiding.png";
import giaikhoinghiep from "../assets/images/giaikhoinghiep.png";
import giaigianhang from "../assets/images/giaigianhang.png";
import giaivannghe from "../assets/images/giaivannghe.png";
import cuocthianh from "../assets/images/cuocthianh.png";
import huongdanthamgia from "../assets/images/huongdanthamgia.png";
import luuyquantrong from "../assets/images/luuyquantrong.png";
import tonggiaithuong from "../assets/images/tonggiaithuong.png";
import titlexephangdoi from "../assets/images/titlexephangdoi.png";
import titlexephangcanhan from "../assets/images/titlexephangcanhan.png";
import khungxanh from "../assets/images/khungxanh.png";
import buttonCaNhan from "../assets/images/buttonCaNhan.png";
import buttonTapThe from "../assets/images/buttonTapThe.png";
import khampha1 from "../assets/images/khampha1.png";
import khampha2 from "../assets/images/khampha2.png";
import khampha3 from "../assets/images/khampha3.png";
import khampha4 from "../assets/images/khampha4.png";
import khampha5 from "../assets/images/khampha5.png";
import khampha6 from "../assets/images/khampha6.png";
import khampha7 from "../assets/images/khampha7.png";
import khampha8 from "../assets/images/khampha8.png";
import khampha9 from "../assets/images/khampha9.png";
import samset from "../assets/images/samset.png";
import huyhieutapthe from "../assets/images/huyhieutapthe.png";
import huyhieucanhan from "../assets/images/huyhieucanhan.png";
import hang1canhan from "../assets/images/hang1canhan.png";
import hang2canhan from "../assets/images/hang2canhan.png";
import hang3canhan from "../assets/images/hang3canhan.png";
import harmony from "../assets/images/harmony.png";
import heart from "../assets/images/heart.png";
import myu from "../assets/images/myu.png";
import sync from "../assets/images/sync.png";
import connect from "../assets/images/connect.png";
import global from "../assets/images/global.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CustomCarousel from "../components/Slider/slider";
import { mission, result } from "../controller";
import { color } from "highcharts";
import { userEvent } from "../controller";
import Noti from "../components/Noti";

const initialTasks = [
  {
    id: "1",
    title: "Nhiệm vụ 01: +20 điểm",
    description: (
      <>
        <b>
          Quay một đoạn clip ngắn (vlog, phỏng vấn, review…) chia sẻ trải
          nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn Hiến,
          có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng viên,
          hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Thời lượng clip: 1–3 phút</li>
          <li>
            Chất lượng clip: Hình ảnh rõ nét, ánh sáng đầy đủ, âm thanh rõ ràng.
          </li>
          <li>
            Nội dung: Là những trải nghiệm cá nhân, chân thực tại giảng đường
            hoặc trong các hoạt động gắn với Văn Hiến.
          </li>
          <li>
            Kênh đăng tải: Clip cần được đăng tải công khai tại 1 trong các nền
            tảng mạng xã hội cá nhân: Facebook, Tiktok, Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #minigametet2026</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "2",
    title: "Nhiệm vụ 02: +10 điểm",
    description: (
      <>
        <b>
          Chụp và đăng tải một bức ảnh check-in tại Đại học Văn Hiến chia sẻ
          trải nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn
          Hiến, có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng
          viên, hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Hình ảnh rõ ràng, sắc nét và đạt chất lượng tốt.</li>
          <li>
            Caption thể hiện được những chia sẻ, cảm nghĩ, tình cảm với VHU.
          </li>
          <li>
            Hình thức: có thể là ảnh tự chụp, tự thiết kế, vẽ tay, hoặc sáng tạo
            bất kỳ có liên quan đến Đại học Văn Hiến
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, YouTube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #minigametet2026</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "3",
    title: "Nhiệm vụ 03: +5 điểm",
    description: (
      <>
        <b>
          Chia sẻ những khoảnh khắc đáng nhớ của cá nhân hoặc cùng bạn bè, đồng
          nghiệp, giảng viên tại lớp học, câu lạc bộ hoặc trong các hoạt động,
          sự kiện, không gian của Đại học Văn Hiến.
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Chất lượng hình ảnh: Rõ nét, phù hợp với tinh thần và tiêu chí của
            chương trình.
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #minigametet2026</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "4",
    title: "Nhiệm vụ 04: +2 điểm",
    description: (
      <>
        <b>
          Chia sẻ ở chế độ công khai các bài đăng từ các kênh mạng xã hội của
          Đại học Văn Hiến (Fanpage, Zalo, Tiktok, Website…) lên các tài khoản
          mạng xã hội cá nhân của bạn.
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Bài đăng ở chế độ công khai</li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #minigametet2026</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
];

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // Đăng ký plugin để hiển thị nhãn dữ liệu trên biểu đồ
);

export const options = (title) => {
  return {
    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      datalabels: {
        align: "end", // align at end of bar
        anchor: "", // anchor to end of bar
        offset: 4, // small space from edge
        color: "white",
        font: {
          size: 12,
          weight: "bold",
        },
        formatter: (value) => {
          return value > 0 ? value : null; // only show if > 0
        },
        clamp: true, // prevent from going outside chart
      },
      legend: {
        display: false,
      },
      tooltip: {
        // backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        // borderColor: "transparent",
        // borderWidth: 1,
      },
      title: {
        display: true,
        text: title,
        color: "white",
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục X
        },
      },
      y: {
        ticks: {
          color: "#ffffff", // màu chữ trên trục Y
        },
      },
    },
  };
};

export default function Events() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(initialTasks);
  const [openTask, setOpenTask] = useState(null);
  // const [groupData, setGroupData] = useState();
  const [teamsData, setTeamsData] = useState([]);
  const [teamsDataCLB, setTeamsDataCLB] = useState([]);
  const [topUserData, setTopUserData] = useState([]);
  const [topUserDataGiangVien, setTopUserDataGiangVien] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("hhh");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [selectedTeamName, setSelectedTeamName] = useState("");
  const [submitStatus, setSubmitStatus] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState({});
  const [submitLink, setSubmitLink] = useState({
    // 1 là tập thể, 2 là cá nhân
    1: "",
    2: "",
  });
  const [lastFetchTime, setLastFetchTime] = useState(0);

  useEffect(() => {
    // scroll to top when component mounts
    window.scrollTo(0, 0);

    // Hàm kiểm tra thời gian đóng/mở
    const checkCloseTime = () => {
      const now = new Date();
      // Đóng từ 23:59:00 ngày 19/10/2025
      const closeTime = new Date(2025, 12, 19, 23, 59, 0, 0); // Tháng 10 là 9 (JS month 0-based)
      if (now >= closeTime) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
    };
    checkCloseTime(); // Kiểm tra ngay khi vào trang
    // Thiết lập interval kiểm tra mỗi phút
    const interval = setInterval(checkCloseTime, 20 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Create combined options array
  const teamOptions = ["Harmony", "Heart", "Global", "myU", "Connect", "Sync"];

  // Map names to image paths
  const getImagePath = (name) => {
    // Create mapping for specific names first

    // KHOA mapping
    if (name === "Harmony") {
      return harmony;
    } else if (name === "Heart") {
      return heart;
    } else if (name === "Global") {
      return global;
    } else if (name === "myU") {
      return myu;
    } else if (name === "Connect") {
      return connect;
    } else if (name === "Sync") {
      return sync;
    }
  };

  const TaskPopup = ({ task, onClose }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-[#0091EB]/90 rounded-2xl shadow-xl max-w-2xl max-md:max-w-full max-md:mx-4 w-full py-4 relative animate-fadeIn">
        <div className="transform -translate-y-8 scale-[1.02] border w-full bg-gradient-to-b from-[#07B4FE] to-[#0044D7] rounded-3xl relative z-10 flex items-center justify-center leading-tight h-fit p-4">
          <button
            className="absolute top-2 right-4 text-2xl text-white hover:text-red-500"
            onClick={onClose}
          >
            &times;
          </button>
          <h2 className="bg-gradient-to-b leading-normal text-5xl max-lg:text-2xl text-center from-[#FFD942] via-[#FFA22F] to-[#FF7E22] bg-clip-text text-transparent font-bold">
            {task.title}
          </h2>
        </div>
        <div className="text-white text-xl px-6">{task.description}</div>
      </div>
    </div>
  );

  // Confirmation popup component
  const ConfirmationPopup = ({ teamName, onConfirm, onCancel }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Xác nhận chọn đội
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          Bạn có chắc chắn muốn chọn <strong>{teamName}</strong> làm đội của
          mình không?
        </p>
        <div className="flex gap-4">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Hủy
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2 bg-gradient-to-r from-[#0253e1] to-[#25c8ff] text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );

  // Handle team selection click
  const handleTeamSelection = async (teamName) => {
    try {
      // Check if user already has a team
      const userEventData = await userEvent.getUserEvent({
        phoneNumber: sessionStorage.getItem("phoneNumber"),
        event: "minigametet2026",
      });

      if (userEventData?.userEvent?.team) {
        // User already has a team, navigate directly to TeamPage
        sessionStorage.setItem("team", userEventData.userEvent.team);
        alert("Bạn đã có đội thi: " + userEventData.userEvent.team);
        navigate("/user/teams/" + userEventData.userEvent.team);
      } else {
        // User doesn't have a team, show confirmation popup
        setSelectedTeamName(teamName);
        setShowConfirmPopup(true);
      }
    } catch (error) {
      console.error("Error checking user team:", error);
      // If error occurs, show confirmation popup as fallback
      setSelectedTeamName(teamName);
      setShowConfirmPopup(true);
    }
  };

  // Handle team selection confirmation
  const handleConfirmTeamSelection = async () => {
    try {
      // Call updateTeam API
      const result = await userEvent.updateTeam({
        phoneNumber: sessionStorage.getItem("phoneNumber"),
        event: "minigametet2026",
        team: selectedTeamName,
      });

      if (result) {
        // Success - navigate to TeamPage
        setShowConfirmPopup(false);
        sessionStorage.setItem("team", selectedTeamName);
        alert("Đăng ký đội thi thành công: " + selectedTeamName);
        navigate("/user/teams/" + selectedTeamName);
      } else {
        alert("Có lỗi xảy ra khi chọn đội. Vui lòng thử lại!");
      }
    } catch (error) {
      console.error("Error updating team:", error);
      alert("Có lỗi xảy ra khi chọn đội. Vui lòng thử lại!");
    }
  };

  // Handle team selection cancellation
  const handleCancelTeamSelection = () => {
    setShowConfirmPopup(false);
    setSelectedTeamName("");
  };
  const fetchGroupResult = useCallback(async () => {
    try {
      const response = await result.getTeamsResult();
      const data = Object.entries(response)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 10) // Chỉ lấy top 10
        .map(([key, value]) => ({ key, value }));
      setTeamsData(data);
    } catch (error) {
      console.log(error);
    }
  }, []);
  const getTop10ResultSinhVien = useCallback(async () => {
    const now = Date.now();
    // Throttle: chỉ cho phép gọi API mỗi 10 giây
    if (now - lastFetchTime < 10000) {
      console.log("Throttled: Too many requests. Please wait 10 seconds between calls.");
      return;
    }
    
    try {
      setLastFetchTime(now);
      const response = await result.getTop10Result();
      setTopUserData(response);
    } catch (error) {
      console.log(error);
    }
  }, [lastFetchTime]);

  const getTop10ResultGiangVien = async () => {
    try {
      const response = await result.getTop10Result();
      setTopUserDataGiangVien(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // Fetch dữ liệu lần đầu khi component mount
    // fetchGroupResult();
    getTop10ResultSinhVien();
    
    // Thiết lập interval để fetch dữ liệu mỗi 60 giây
    const interval = setInterval(() => {
      // fetchGroupResult();
      getTop10ResultSinhVien();
    }, 60000);
    
    return () => clearInterval(interval);
  }, [getTop10ResultSinhVien]);
  const scrollToSection = (id) => {
    // setShowMenu(false);
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 200); // Wait for menu to close
  };

  const handleSubmit = async (id) => {
    if (isClosed) {
      alert("Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi!");
      return;
    }
    try {
      // setIsLoading(true);
      const result = await mission.createSubmission({
        userEventId: JSON.parse(sessionStorage.getItem("userInfo")).userEvent
          .id,
        mission: Number(id),
        link: submitLink[id],
      });
      if (result.message === "Submission created successfully") {
        setSubmitStatus(true);
        // setTasks((tasks) =>
        //   tasks.map((task) => (task.id === id ? { ...task, input: "" } : task))
        // );
        // Refresh submissions after successful submit and reset to first page
        // setSubmissionPagination((prev) => ({ ...prev, page: 1 }));
        // fetchSubmissions(1, submissionPagination.limit);
      } else {
        throw new Error(result.message || "Failed to submit task");
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      alert(error.message || "Failed to submit task");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserEvent = async () => {
    try {
      setIsLoading(true);
      const response = await userEvent.getUserEvent({
        phoneNumber: sessionStorage.getItem("phoneNumber"),
        event: "minigametet2026",
      });
      if (response) {
        // console.log("User events fetched successfully:", response);
        sessionStorage.setItem(
          "userInfo",
          JSON.stringify({ userEvent: response.userEvent })
        );
        setInfo({
          name: response?.userEvent?.name || "User",
          id: response?.userEvent?.id || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserEvent();
  }, []);

  return (
    <div
      // style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover" }}
      className=" min-h-screen pb-10 relative bg-[#0043D3] bg-no-repeat bg-cover bg-center"
    >
      <Header />
      {submitStatus && (
        <Noti
          message={<span>Đã gửi kết quả nhiệm vụ thành công!</span>}
          onClose={() => setSubmitStatus(false)}
        ></Noti>
      )}
      <div className="w-11/12  mx-auto p-4">
        {/* Popup Task */}
        {openTask && (
          <TaskPopup task={openTask} onClose={() => setOpenTask(null)} />
        )}
        {showConfirmPopup && (
          <ConfirmationPopup
            teamName={selectedTeamName}
            onClose={() => setShowConfirmPopup(false)}
            onConfirm={handleConfirmTeamSelection}
            onCancel={handleCancelTeamSelection}
          />
        )}
        <div className="banner flex items-stretch gap-10 justify-between max-md:flex-col max-md:items-start max-md:gap-4 mt-10 mb-20">
          <div className="banner_left basis-5/12 flex flex-col items-start justify-center pr-4">
            <img
              className="mt-4 w-full object-cover"
              src={leftBannerText}
            ></img>
            {/* <img className="mt-4" src={niemtinHUNGHAU}></img> */}
            <span className="text-lg text-white mt-4 font-medium">
              Hành trình kết nối những thế hệ sinh viên Văn Hiến trong cùng nhịp
              đập – nơi của tuổi trẻ, sáng tạo và nhiệt huyết bùng nổ.
              <br />
              Trở về” – không chỉ là khoảnh khắc gặp lại, mà là hành trình kết
              nối những thế hệ sinh viên Văn Hiến, cùng hòa chung nhịp đập trẻ
              trung, sáng tạo và đầy cảm xúc.
              <br />
              Hãy lưu giữ và chia sẻ khoảnh khắc đáng nhớ nhất của bạn trong
              chuỗi sự kiện Lễ Khai giảng – Ngày hội Sinh viên & Gala “myU26,
              Trở về để đồng hành”.
            </span>
            <button
              onClick={() => scrollToSection("section-submit")}
              className="mt-4 text-[20px] px-8 py-3  bg-gradient-to-r from-[#f23f0f] to-[#fcc606] text-white rounded-full hover:opacity-90 transition-opacity w-full"
            >
              THAM GIA NGAY {"->"}
            </button>
          </div>
          <div className="banner_right basis-7/12 gap-4  items-end ">
            <img
              className="max-h-[500px] col-span-3  w-full object-cover"
              src={hunghaumungtruyenthong}
              alt="img-1"
            />
          </div>
        </div>

        <div className="banner_bottom mt-10 w-full grid grid-cols-3 max-md:grid-cols-1 gap-4">
          <img className="w-full object-cover" src={banner_bottom1}></img>
          <img className="w-full object-cover" src={banner_bottom2}></img>
          <img className="w-full object-cover" src={banner_bottom3}></img>
          <img className="w-full object-cover" src={banner_bottom4}></img>
          <img className="w-full object-cover" src={banner_bottom5}></img>
          <img className="w-full object-cover" src={banner_bottom6}></img>
        </div>

        {/* Teams Section */}
        <div className="mt-20">
          <h2 className="text-4xl font-bold text-center text-white mb-10">
            CHỌN ĐỘI CỦA BẠN
          </h2>
          <div className="grid grid-cols-3 max-md:grid-cols-2 gap-6">
            {teamOptions.map((teamName, index) => (
              <div
                key={index}
                onClick={() => handleTeamSelection(teamName)}
                className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 hover:bg-white/20 transition-all duration-300 cursor-pointer hover:scale-105 transform flex flex-col items-center justify-center gap-4 border-2 border-white/20 hover:border-white/40"
              >
                <img
                  src={getImagePath(teamName)}
                  alt={teamName}
                  className="w-32 h-32 object-contain"
                />
                <h3 className="text-2xl font-bold text-white text-center">
                  {teamName}
                </h3>
              </div>
            ))}
          </div>
        </div>

        <div
          id="section-nhiemvu"
          className="grid grid-cols-1 gap-4 max-md:grid-cols-1  items-stretch w-11/12 mx-auto font-thin"
        >
          <div id="section-thele" className="relative mt-40 p-8">
            <div className="w-full">
              <h2 className="text-[#00FFFF] text-2xl font-bold text-center">
                CUỘC THI ẢNH
                <br></br>
                "MYU26, TRỞ VỀ ĐỂ ĐỒNG HÀNH"
              </h2>
            </div>
            <div className="mt-10" id="huongdanthamgia">
              <img
                className="min-w-7/12 object-fit"
                src={huongdanthamgia}
              ></img>
              <div className="text-white text-lg mt-4 gap-4">
                <strong>Bước 1:</strong> Thành viên truy cập vào Landing Page và
                sẵn sàng lan toả không khí của chương trình Lễ Khai giảng – Ngày
                hội sinh viên – Gala "Trở về, myU26".
                <br></br>
                <strong>Bước 2:</strong> Hãy chia sẻ hình ảnh cá nhân và tập thể
                tại chương trình ở chế độ công khai trên các nền tảng mạng xã
                hội: Facebook, TikTok, Instagram, LinkedIn…
                <ul className="list-disc ml-5 mt-2">
                  <li>
                    Chia sẻ hình ảnh thành công:{" "}
                    <b className="text-[#00FF00]">+3 điểm</b>
                  </li>
                </ul>
                <b>
                  Lưu ý: bài đăng đi kèm các hashtag #VHEEcosystem #VHU
                  #DaihocVanHien #VanhienUniversity #SyncGatherDevote
                  #Trovededonghanh #myU26TroVe
                </b>
                <br></br>
                <strong>Bước 3:</strong> Sau khi đăng bài, hãy quay trở lại
                trang Landing Page cập nhật link bài viết để hệ thống ghi nhận
                kết quả và cộng điểm.
                <br></br>
                <strong>Bước 4:</strong> Tiếp tục chia sẻ hình ảnh cá nhân và
                tập thể lên các nền tảng mạng xã hội mỗi ngày và theo dõi bảng
                xếp hạng để cùng đồng đội chinh phục ngôi vị dẫn đầu!
              </div>
            </div>
            <div id="luuyquantrong" className="mt-10">
              <img src={luuyquantrong}></img>
              <div className="text-white text-lg mt-4 gap-4">
                <b>
                  1. Thời gian tham gia:{" "}
                  <span className="text-[#FFC800]">
                    {" "}
                    Từ 29/10/2025 đến 17h00 ngày 05/11/2025
                  </span>
                </b>
                <br></br>
                <b>2. Nội dung và hình ảnh chia sẻ:</b>
                <ul className="list-disc ml-5 mt-2">
                  <li>
                    Hình ảnh chia sẻ là hình cá nhân hoặc tập thể trong chương
                    trình Lễ Khai giảng –  Ngày hội sinh viên – Gala "Trở về,
                    myU26" được Đại học Văn Hiến tổ chức vào ngày 29-30/10/2025.
                  </li>
                  <li>
                    Hình ảnh phải được chia sẻ ở chế độ công khai trên các nền
                    tảng xã hội.
                  </li>
                  <li>
                    Bài đăng phải có caption phù hợp và các hashtag đi kèm: #VHU
                    #DaihocVanHien #VanhienUniversity #SyncGatherDevote
                    #Trovededonghanh #myU26 #minigametet2026 #Galatrove
                  </li>
                  <li>
                    Hình ảnh có chất lượng rõ nét, nội dung chia sẻ có ngôn từ
                    phù hợp với thuần phong mỹ tục, thể hiện được tinh thần
                    chương trình và không vi phạm các tiêu chuẩn cộng đồng.
                  </li>
                  <li>
                    Các hình ảnh và nội dung đăng tải không được trùng lặp trên
                    cùng một nền tảng.
                  </li>
                  <li>
                    Mỗi bài đăng (01 đường link) chỉ được tính điểm một lần duy
                    nhất. Có thể sử dụng cùng một hình ảnh và nội dung để chia
                    sẻ trên nhiều nền tảng xã hội khác nhau.
                  </li>
                </ul>
                <b>3. Quy định từ Ban Tổ chức:</b>
                <ul className="list-disc ml-5 mt-2">
                  <li>
                    Mỗi thành viên có thể chia sẻ hình ảnh và tham gia không
                    giới hạn trong thời gian chương trình diễn ra.
                  </li>
                  <li>
                    Bài đăng chỉ được tính hợp lệ khi đáp ứng đầy đủ các tiêu
                    chí: hashtag, caption, hình rõ nét và ở chế độ công khai.
                  </li>
                  <li>
                    Bài đăng đã xóa hoặc đổi chế độ riêng tư trong hoặc sau thời
                    gian diễn ra chương trình sẽ không được tính điểm.
                  </li>
                  <li>
                    Ban Tổ chức sẽ loại bỏ hoặc trừ điểm các trường hợp sai quy
                    định, sử dụng hình ảnh hoặc nội dung không phù hợp.
                  </li>
                  <li>
                    Ban Tổ chức có thể sử dụng hình ảnh, nội dung bài đăng của
                    người tham gia cho mục đích truyền thông, quảng bá chương
                    trình.
                  </li>
                  <li>
                    Trong mọi trường hợp, quyết định của Ban Tổ chức là quyết
                    định cuối cùng.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div
          id="section-nhiemvu"     
          className="grid grid-cols-2 gap-4 max-md:grid-cols-1 mt-40 items-stretch"
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner_bottom1}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "1"))}
                className=" bg-white hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className=" text-2xl max-lg:text-lg text-center bg-gradient-to-br from-[#F1039C] to-[#B8C2CE] bg-clip-text text-transparent font-bold overflow-clip w-full">
                  NHIỆM VỤ 1
                </h2>
              </div>
            </div>
            <div className="flex flex-col gap-4 grow">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner_bottom1}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "2"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#FF530A] to-[#FFDD1F] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className="text-white text-2xl max-lg:text-lg text-center text-transparent font-bold">
                  NHIỆM VỤ 2
                </h2>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-4">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner_bottom1}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "3"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#21FF30] to-[#008709] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className=" text-2xl max-lg:text-lg text-center text-white font-bold overflow-clip w-full">
                  NHIỆM VỤ 3
                </h2>
              </div>
            </div>
            <div className="flex flex-col gap-4 grow">
              <img
                alt=""
                className="h-full w-full object-cover rounded-2xl"
                src={banner_bottom1}
              ></img>
              <div
                onClick={() => setOpenTask(tasks.find((t) => t.id === "4"))}
                className="bg-gradient-to-b hover:cursor-pointer hover:scale-105 transition-all duration-200 h-20 from-[#0017AF] to-[#0F2FFF] rounded-2xl p-4 flex flex-col justify-center items-center"
              >
                <h2 className="bg-gradient-to-b text-2xl max-lg:text-lg text-center from-[#00FCED] to-[#B8C2CE] bg-clip-text text-transparent font-bold">
                  NHIỆM VỤ 4
                </h2>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <div id="section-submit" className="w-11/12 mx-auto">
        <div className="w-full p-4 rounded-2xl mt-20">
          <div className="w-full flex flex-col items-center">
            <h2 className="text-3xl font-bold text-[#3DC000] mb-8">
              Sinh viên tham gia tại đây
            </h2>
            <div className="w-full flex justify-between bg-[#A7FFA7] rounded-2xl p-4 max-md:flex-col max-md:items-center max-md:gap-4">
              <div className="w-10/12 p-4 flex flex-col gap-4">
                <input
                  onChange={(e) =>
                    setSubmitLink({ ...submitLink, 2: e.target.value })
                  }
                  type="text"
                  placeholder="Nhập Link hình ảnh chia sẻ"
                  className="w-full bg-white rounded-2xl p-2 text-black text-lg"
                />
              </div>
              <button
                disabled={isClosed}
                onClick={() => handleSubmit(2)}
                className="bg-gradient-to-t disabled:cursor-not-allowed from-[#3DC000] to-[#2BFF00] flex-grow text-white px-8 py-4 rounded-2xl hover:opacity-90 transition-opacity max-md:w-full"
              >
                GỬI KẾT QUẢ
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="w-11/12 mx-auto">
        <div id="section-xephang" className="w-full p-4 rounded-2xl mt-40">
          {/* <h2 className="text-3xl font-bold text-white text-center mb-8">
            BẢNG XẾP HẠNG ĐỘI
          </h2> */}
          {/* <img
            src={titlexephangdoi}
            alt="Title Xếp Hạng Đội"
            className="w-full mb-4"
          /> */}
          {/* Dòng thứ hai: 2 bảng tập thể */}
          {/* Bảng xếp hạng tập thể khoa */}
          {/* <div className="grid grid-cols-1 gap-10 max-md:grid-cols-1">
            <div className="w-full h-full flex flex-col gap-2 bg-[#E5FFB9]/20 rounded-2xl p-8 max-md:p-2 border-yellow-500 border-4">
              {teamsData.length > 0 ? (
                <div className=" rounded-2xl flex flex-col h-full">
                  <ul className="flex flex-col justify-between">
                    {" "}
                    {teamsData.map((team, index) => (
                      <li
                        key={index}
                        className="bg-[#0171f9] px-3 mb-2 h-20 flex justify-center items-center gap-6 rounded-lg shadow-md"
                      >
                        <div className="relative w-[10%] h-full max-md:w-[15%] flex items-center justify-center">
                          {index < 3 && (
                            <img
                              alt="avatar"
                              className=" rounded-full object-cover"
                              src={
                                index === 0
                                  ? hang1
                                  : index === 1
                                  ? hang2
                                  : hang3
                              }
                            />
                          )}
                          {index > 2 && (
                            <span
                              className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-white font-bold text-lg pointer-events-none"
                              style={{
                                textShadow: "0 0 6px #000, 0 0 2px #000",
                              }}
                            >
                              {index + 1}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-lg max-md:text-sm font-bold text-white">
                            {team?.key.toUpperCase()}
                          </span>
                        </div>
                        <span className="flex items-center gap-2 w-[30%] justify-end">
                          <span className="bg-gradient-to-r from-[#FC8600] to-[#FFA100] text-white font-bold rounded-lg text-xl px-8 py-4 w-80 text-center">
                            {team.value} thành viên{" "}
                          </span>
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="bg-white rounded-2xl p-4 flex flex-col items-center">
                  <p className="text-lg">Chưa có dữ liệu</p>
                </div>
              )}
            </div>
          </div> */}

          {/* Dòng đầu tiên: 2 bảng cá nhân */}
          {/* <h2 className="text-3xl font-bold text-white text-center mt-10">
            BẢNG XẾP HẠNG CÁ NHÂN
          </h2> */}
          <img
            src={titlexephangcanhan}
            alt="Title Xếp Hạng Cá Nhân"
            className="w-full mb-4 mt-10"
          />
          <div className="grid grid-cols-1 gap-10 max-md:grid-cols-1 mt-10">
            {/* Bảng xếp hạng cá nhân sinh viên */}
            <div className="w-full h-full flex flex-col gap-2 bg-[#B9FFFC]/20 rounded-2xl p-8 max-md:p-2 border-yellow-500 border-4">
              {/* <div className="flex items-center gap-4 justify-center">
                <img
                  src={huyhieucanhan}
                  className=" h-14 object-cover"
                  alt="Huy Hiệu Cá Nhân Sinh Viên"
                />
                <h1 className="text-2xl font-bold text-white text-center ">
                  XẾP HẠNG CÁ NHÂN
                </h1>
              </div> */}
              {topUserData.length > 0 ? (
                <div className=" rounded-2xl flex flex-col h-full ">
                  <ul className="flex flex-col grow justify-start ">
                    {" "}
                    {topUserData.map((user, index) => (
                      <li
                        key={index}
                        className="bg-[#0074f7] px-3 mb-2 h-20 flex justify-center items-center gap-6 rounded-lg shadow-md text-white"
                      >
                        <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center h-full">
                          {index < 3 && (
                            <img
                              alt="avatar"
                              className=" rounded-full object-cover"
                              src={
                                index === 0
                                  ? hang1
                                  : index === 1
                                  ? hang2
                                  : hang3
                              }
                            />
                          )}
                          {index > 2 && (
                            <span
                              className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-white font-bold text-lg pointer-events-none"
                              style={{
                                textShadow: "0 0 6px #000, 0 0 2px #000",
                              }}
                            >
                              {index + 1}
                            </span>
                          )}

                          {/* .//// */}

                          {/* {index < 3 && (
                            <img
                              alt="avatar"
                              className="w-full h-full rounded-full object-fit"
                              src={
                                index === 0
                                  ? hang1
                                  : index === 1
                                  ? hang2
                                  : hang3
                              }
                            />
                          )}
                          {index > 2 && (
                            <span
                              className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-white font-bold text-lg pointer-events-none"
                              style={{
                                textShadow: "0 0 6px #000, 0 0 2px #000",
                              }}
                            >
                              {index + 1}
                            </span>
                          )} */}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-2xl max-md:text-sm font-bold ">
                            {user?.userEvent?.name}
                          </span>
                          {/* {user?.userEvent?.team && (
                            <span className="text-lg max-md:text-xs text-gray-600">
                              {user?.userEvent?.team}
                            </span>
                          )} */}
                        </div>
                        <span className="flex items-center gap-2 w-[30%] justify-end">
                          <span className="bg-gradient-to-r from-[#FC8600] to-[#FFA100] text-white font-bold rounded-lg text-xl px-8 py-4 w-80 text-center">
                            {user.totalScore} điểm{" "}
                          </span>
                          {/* <img
                            className="w-5 h-5"
                            src={samset}
                            alt="samset"
                          ></img> */}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="bg-white rounded-2xl p-4 flex flex-col items-center">
                  <p className="text-lg">Chưa có dữ liệu</p>
                </div>
              )}
            </div>

            {/* Bảng xếp hạng cá nhân giảng viên */}
            {/* <div className="w-full h-full flex flex-col gap-2 bg-[#FFE5B9]/20 rounded-2xl p-8 max-md:p-2">
              <div className="flex items-center gap-4 justify-center">
                <img
                  src={huyhieucanhan}
                  className="h-14 object-cover"
                  alt="Huy Hiệu Cá Nhân Giảng Viên"
                />
                <h1 className="text-2xl font-bold text-white text-center ">
                  XẾP HẠNG GIẢNG VIÊN
                </h1>
              </div>
              {topUserDataGiangVien.length > 0 ? (
                <div className=" rounded-2xl flex flex-col h-full">
                  <ul className="flex flex-col grow justify-start">
                    {" "}
                    {topUserDataGiangVien.map((user, index) => (
                      <li
                        key={index}
                        className="bg-white px-3 mb-2 flex justify-center items-center gap-6 rounded-lg shadow-md"
                      >
                        <div className="relative w-[10%] max-md:w-[15%] flex items-center justify-center">
                          <img
                            alt="avatar"
                            src={
                              index === 0
                                ? hang1canhan
                                : index === 1
                                ? hang2canhan
                                : index === 2
                                ? hang3canhan
                                : hangkhac
                            }
                            className="w-full h-fit rounded-full object-cover max-md:object-cover"
                          />
                          {index > 2 && (
                            <span
                              className="absolute max-md:text-sm w-fit h-fit top-[50%] left-[50%] transform -translate-x-[60%] translate-y-[-50%] inset-0 flex items-center justify-center text-[#1900FB] font-bold text-lg pointer-events-none"
                              style={{
                                textShadow: "0 0 6px #000, 0 0 2px #000",
                              }}
                            >
                              {index + 1}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-col w-[60%]">
                          <span className="text-lg max-md:text-sm font-bold text-[#0009BC]">
                            {user?.userEvent?.name}
                          </span>
                          {user?.userEvent?.team && (
                            <span className="text-sm max-md:text-xs text-gray-600">
                              {user?.userEvent?.team}
                            </span>
                          )}
                        </div>
                        <span className="flex items-center gap-2 w-[30%] justify-end">
                          {user.totalScore} điểm{" "}
                          <img
                            className="w-5 h-5"
                            src={samset}
                            alt="samset"
                          ></img>
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="bg-white rounded-2xl p-4 flex flex-col items-center">
                  <p className="text-lg">Chưa có dữ liệu</p>
                </div>
              )}
            </div> */}
          </div>
        </div>{" "}
      </div>

      <div className="w-11/12 mx-auto">
        <div id="section-giaithuong" className="mt-40">
          <img
            src={giaithuong}
            className="w-full object-cover rounded-3xl"
            alt="Giải thưởng cuộc thi"
          />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}
